import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableInputField = ({ id, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {/* Drag handle */}
                <div
                    {...attributes}
                    {...listeners}
                    style={{ cursor: "grab", padding: "4px" }}
                >
                    <span style={{ fontSize: 16 }}>⋮⋮</span>
                </div>
                {/* Input Field Content */}
                <div style={{ flexGrow: 1 }}>{children}</div>
            </div>
        </div>
    );
};

export default SortableInputField;
